import { render } from "./AppSectionCard.vue?vue&type=template&id=0f52fc45&scoped=true&ts=true&lang=pug"
import script from "./AppSectionCard.vue?vue&type=script&lang=ts"
export * from "./AppSectionCard.vue?vue&type=script&lang=ts"

import "./AppSectionCard.vue?vue&type=style&index=0&id=0f52fc45&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f52fc45"]])

export default __exports__